import i18next from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  apiToken: Yup.string().required(i18next.t('validation.required.token')),
  validUntil: Yup.date(),
});
